<div class="header">
  <button mat-icon-button class="mat-icon-action-button-lg-with-border back-button" (click)="backEvent.emit()" matTooltip="back" matTooltipPosition="above" matTooltipClass="bms-theme">
    <mat-icon svgIcon="solid-arrow-back" />
  </button>
  <vdw-ellipsis-label class="font-weight-semibold header-title" [text]="title()"></vdw-ellipsis-label>
  @if (isLocked()) {
    <vdw-lock-icon class="ml-2" [config]="lockIconConfig()"></vdw-lock-icon>
  }
</div>
